import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { publicAxios } from '../api';

const initialState = {
  constructionServices: [],
  status: 'idle',
  error: null,
};

export const fetchConstructionServices = createAsyncThunk('constructionServices/fetchConstructionServices', async () => {
  const response = await publicAxios.get('/api/user/newconstruction/construction_subtype');
  return response.data.data.construction_subtype;
});

const constructionServicesSlice = createSlice({
  name: 'constructionServices',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConstructionServices.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchConstructionServices.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.constructionServices = action.payload;
      })
      .addCase(fetchConstructionServices.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default constructionServicesSlice.reducer;